// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InvitationDocuments-doc[data-v-073b18d6]{display:inline-block;border:1px solid #ddd;border-radius:6px;padding:10px 20px;margin:10px 10px 10px 0;background-color:#f3efef}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
